import 'css-chunksrc/client/pages/projectPage/resourcesPage/styles.scss';export default {
  "resourcesPage": "_resourcesPage_1986i_1",
  "filters": "_filters_1986i_10",
  "viewFilter": "_viewFilter_1986i_18",
  "main": "_main_1986i_26",
  "sidebar": "_sidebar_1986i_31",
  "toggleViewButton": "_toggleViewButton_1986i_42",
  "exportButton": "_exportButton_1986i_54"
};